import { useMemo } from 'react';

import { collection, doc, DocumentReference } from 'firebase/firestore';

import { useDocumentData } from 'react-firebase-hooks/firestore';

import { useData } from '../contextProviders/DataProvider';
import { firestore } from '../firebase';
import Competition from '../types/Competition';

export default function useCompetition(competitionId: string | undefined) {
  const { userState } = useData();

  const competitionRef = useMemo(() => {
    if (!competitionId) return null;
    if (userState.status !== 'ready' || !userState.userProfile) return null;
    return doc(collection(firestore, 'competition'), competitionId) as DocumentReference<Competition>;
  }, [competitionId, userState.userProfile, userState.status]);

  const [competition, isCompetitionLoading, competitionError] = useDocumentData<Competition>(competitionRef);

  if (!competitionId) {
    return { competition: null, isCompetitionLoading: false };
  }

  if (userState.status === 'logged_out') {
    return {
      competition: null,
      isCompetitionLoading: false,
      competitionError: new Error('User must be logged in to view competitions'),
    };
  }

  return {
    competition: competition ?? null,
    isCompetitionLoading:
      isCompetitionLoading ||
      userState.status === 'authenticating_user' ||
      userState.status === 'authenticating_profile' ||
      userState.status === 'authenticating_memberships',
    competitionError,
  };
}
